export const paths = {
  management: "/management",

  stats: "/statistics",

  appointments: "/appointments",

  settings: "/settings",

  createAppointment: "/create-appointment",

  clients: "/clients",

  clientMemberShip: (id) => `/client/${id}`,

  clientHistory: (id) => `/client-history/${id}`,

  workingHours: (id) => `/working-hours/${id}`,

  memberShips: "/memberships",

  employees: "/employees",

  services: "/services",

  createService: "/services/create",

  editService: (id) => `/services/edit/${id}`,

  class: (appointmentId, employeeId) => `/class/${appointmentId}/${employeeId}`,

  createNotifications: "/create-notifications",

  notifications: "/notifications",

  profile: "/profile",

  subscription: "/subscription",

  invoices: "/invoices",

  documents: "/documents",

  contact: "/contact",

  coupons: "/coupons",

  couponsUsageHistory: "/coupons-usage-history",

  giftCards: "/gift-cards",

  giftCardPurchaseHistory: "/gift-cards-purchase-history",

  giftCardConsumptionHistory: "/gift-cards-consumption-history",
  
  giftCardConsumptionHistoryByCode: (code) => `/gift-cards-consumption-history/${code}`,

  paymentSettings: "/settings/payment",

  clientBilling: (id) => `/client-billing/${id}`,

  messageTemplates: "/message-templates",

  messageHistory: "/message-history",

  login: "/auth/login",

  forms: "/forms",

  paymentRequests: "/payment-requests",
  automations: "/automations",
  reviews: "/reviews",
  appointmentRequests: "/appointment-requests",
  scheduleOverride: "/schedule-override",
  reminders: "/reminders",
  openfrmtExport: "/reports/openfrmt-export",
  cashRegister: "/cash-register",
  products: "/products",
  purchases: "/purchases",
  allMemberships: "/memberships/all",
  whatsappBot: "/whatsapp-bot",
};
